/* eslint-disable @typescript-eslint/no-explicit-any */

'use client';

import { ClientLogger } from '@/lib/logger/pino-logger.client';
import { useState } from 'react';

interface IUseRequestConfig {
  method?: 'get' | 'post' | 'put' | 'delete';
  logger?: ClientLogger;
}

export const useRequest = <T = unknown, I = any>(path: string, { method = 'post', logger }: IUseRequestConfig) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const sendRequest = async (data?: I): Promise<T | undefined> => {
    try {
      setIsLoading(true);
      setHasError(false);

      const _method = method.toUpperCase();

      const queryString = data ? new URLSearchParams(data as any).toString() : '';
      const url = _method === 'GET' ? (queryString ? `${path}?${queryString}` : path) : path;
      const body = (_method === 'POST' || _method === 'PUT') && data !== undefined ? JSON.stringify(data) : undefined;

      const response = await fetch(url, {
        method: _method,
        ...(body !== undefined && {
          headers: { 'Content-Type': 'application/json' },
          body,
        }),
      });

      if (!response.ok) throw new Error(response.statusText);

      const json = await response.json().catch(() => null);

      return (json ?? true) as T;
    } catch (error) {
      logger?.error((error as Error).message);
      setHasError(true);
      return;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    hasError,
    sendRequest,
  };
};
